export default "__VITE_ASSET__CJL7Fpj5__"